import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import About from "../About";
import Home from "../Home";
import Header from "../Header";
import Footer from "../Footer";
import Contact from "../Contact";
import { ScrollTop } from "primereact/scrolltop";
import ProductDropdowns from "../Modules/ProductDropdowns/ProductDropdowns";
import MySqlKbDetails from "../Modules/ProductDropdowns/MySqlKbDetails";
import { useEffect } from "react";

function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
  return null;
}

function PageRoutes() {
  return (
    <Router>
      <Header />
      <ScrollToTopOnRouteChange />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/MsSqlDropdown" element={<ProductDropdowns />} />
        <Route path="/MySqlDropdown" element={<MySqlKbDetails />} />
      </Routes>
      {/* <ScrollTop threshold={100} icon="pi pi-arrow-up" /> */}
        <ScrollTop
  style={{
    position: "fixed",
    bottom: "20px",
    right: "20px",
    backgroundColor: "#007bff", // Button ka color
    color: "#fff",
    borderRadius: "50%", // Circle shape
    width: "50px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
    cursor: "pointer",
    zIndex: 9999,
  }}
/>
      <Footer />
    </Router>
  );
}

export default PageRoutes;
